// eslint-disable-next-line import/prefer-default-export, max-len
export var instagram = function instagram(value) {
  return /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/.test(value) || 'Provide a valid url';
};